import script from "./MyFormSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyFormSection.vue?vue&type=script&lang=ts&setup=true"

import "./MyFormSection.vue?vue&type=style&index=0&id=f0d3cf78&lang=scss"

const __exports__ = script;

export default __exports__